import { _ } from "src/services";

export const ProfileSitePackageBoxShimmer: React.FC = () => {

    return (
        <div className="profile-package shimming">
            <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center">
                    <div className="package-logo shimmer" />
                    <span className="package-title shimmer"></span>
                </div>
                <div className="flex-1"></div>
                <span className="btn btn-packages disabled">{_("selectAndContinue")} </span>
            </div>
            <ul className="description">
                {[...new Array(4)].map((x, i) => <li key={i}><span className="w-100 shimmer"></span></li>)}
            </ul>
        </div>

    );

};